import { useState } from "react";
import { ChevronDown, ChevronUp, History } from "lucide-react";

const LABELS = {
  name: "Name", age: "Age", show_name: "Show name", project_title: "Project title", project_description: "Project description",
  project_serves: "Who it serves", project_when: "When", city: "City", state: "State", quote: "Quote", instagram: "Instagram",
  media_contact_name: "Media contact name", media_contact_email: "Media contact email", media_contact_phone: "Media contact phone",
  published: "Published", gallery_opt_in: "Gallery opt-in", frame_id: "Frame", photo: "Photo", status: "Status",
};

function fmt(iso) {
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }); }
  catch { return iso; }
}
const short = (v) => { const s = v === null || v === undefined || v === "" ? "—" : String(v); return s.length > 60 ? s.slice(0, 57) + "…" : s; };

function Entry({ e }) {
  const who = e.by_role === "owner" ? `${e.by} (winner)` : `${e.by} (${e.by_role})`;
  const verb = e.action === "approve" ? "approved this page" : e.action === "reject" ? "rejected this page"
    : e.action === "trash" ? "moved this page to Trash" : e.action === "restore" ? "restored this page from Trash"
    : e.action === "resend_welcome" ? "resent the welcome email"
    : e.action === "press_release_edit" ? "edited the press release" : e.action === "press_release_regenerate" ? "regenerated the press release"
    : e.action === "press_release_approve" ? "approved & emailed the press release" : "edited this page";
  const fields = Object.entries(e.changes || {});
  return (
    <div className="rounded-xl bg-white p-3 text-xs ring-1 ring-sbg-raspberry/10" data-testid="history-entry">
      <div className="font-semibold text-sbg-burgundy">
        <span className={e.by_role === "owner" ? "text-sbg-fuchsia" : "text-pt-purple"}>{who}</span> {verb}
        <span className="ml-2 font-normal text-sbg-burgundy/50">{fmt(e.at)}</span>
      </div>
      {fields.length > 0 && (
        <ul className="mt-1.5 space-y-0.5 text-sbg-burgundy/70">
          {fields.map(([k, v]) => (
            <li key={k}><span className="font-semibold">{LABELS[k] || k}:</span> {short(v?.from)} → <span className="text-sbg-burgundy">{short(v?.to)}</span></li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function ChangeHistory({ history = [] }) {
  const [open, setOpen] = useState(false);
  if (!history.length) return <p className="text-xs text-sbg-burgundy/50" data-testid="history-empty">No changes logged yet.</p>;
  const [latest, ...rest] = history;
  return (
    <div data-testid="change-history">
      <div className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-sbg-raspberry"><History className="h-3.5 w-3.5" /> Latest change</div>
      <Entry e={latest} />
      {rest.length > 0 && (
        <>
          <button type="button" data-testid="history-toggle" onClick={() => setOpen((o) => !o)} className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-sbg-burgundy/70 hover:text-sbg-burgundy">
            {open ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />} {open ? "Hide" : "Show"} full history ({rest.length} earlier)
          </button>
          {open && <div className="mt-2 space-y-2">{rest.map((e) => <Entry key={e.id} e={e} />)}</div>}
        </>
      )}
    </div>
  );
}
